import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import LandingPage from '../../pages/Landing';

const SingleWork = lazy(() => import('../../pages/SingleWork'));
const ECommerceGCC = lazy(() => import('pages/ECommerceGCC'));
const NotFound = lazy(() => import('../../pages/404'));
const Schedule = lazy(() => import('pages/Schudule/Schedule'));
const Success = lazy(() => import('pages/Schudule/Success'));
const Portfolio = lazy(() => import('../../pages/Portfolio'));
const CSFocus = lazy(() => import('pages/CaseStudy/CSFocus'));
const CSLoha = lazy(() => import('pages/CaseStudy/CSLoha'));
const CSLohaML = lazy(() => import('pages/CaseStudy/CSLohaML'));
const CSBuildex = lazy(() => import('pages/CaseStudy/CSBuildex'));
const { WebsitesDev, SoftwearDev, MobileDev } = {
  WebsitesDev: lazy(() =>
    import('../../pages/service/Services').then((m) => ({ default: m.WebsitesDev }))
  ),
  SoftwearDev: lazy(() =>
    import('../../pages/service/Services').then((m) => ({ default: m.SoftwearDev }))
  ),
  MobileDev: lazy(() =>
    import('../../pages/service/Services').then((m) => ({ default: m.MobileDev }))
  ),
};

export const publicRoutes: RouteObject[] = [
  { path: '/', element: <LandingPage /> },
  { path: '/work/:id', element: <SingleWork /> },

  { path: '/eCommerce/GCC', element: <ECommerceGCC /> },
  { path: '/404', element: <NotFound /> },

  {
    path: '/schedule',
    children: [
      { path: '', element: <Schedule /> },
      { path: 'success', element: <Success /> },
    ],
  },

  {
    path: '/services',
    children: [
      {
        path: 'website',
        element: <WebsitesDev />,
      },
      {
        path: 'softwear',
        element: <SoftwearDev />,
      },
      {
        path: 'mobileapp',
        element: <MobileDev />,
      },
    ],
  },

  {
    path: '/portfolio',
    children: [
      {
        path: '',
        element: <Portfolio />,
      },
      {
        path: 'focus',
        element: <CSFocus />,
      },
      {
        path: 'loha',
        element: <CSLoha />,
      },
      {
        path: 'buildex',
        element: <CSBuildex />,
      },
    ],
  },
  {
    path: '/ml',
    children: [
      { path: '', element: <LandingPage /> },
      { path: 'work/:id', element: <SingleWork /> },
      { path: 'eCommerce/GCC', element: <ECommerceGCC /> },
      { path: '404', element: <NotFound /> },
      {
        path: 'schedule',
        children: [
          { path: '', element: <Schedule /> },
          { path: 'success', element: <Success /> },
        ],
      },
      {
        path: 'services',
        children: [
          {
            path: 'website',
            element: <WebsitesDev />,
          },
          {
            path: 'softwear',
            element: <SoftwearDev />,
          },
          {
            path: 'mobileapp',
            element: <MobileDev />,
          },
        ],
      },
      {
        path: 'portfolio',
        children: [
          {
            path: '',
            element: <Portfolio />,
          },
          {
            path: 'focus',
            element: <CSFocus />,
          },
          {
            path: 'loha',
            element: <CSLohaML />,
          },
          {
            path: 'buildex',
            element: <CSBuildex />,
          },
        ],
      },
    ],
  },
];

export const authRoutes: RouteObject[] = [];
